import React from 'react'
import { useTranslation } from 'react-i18next'
import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { IPostElementProps } from '../../../../../types/types'

const ShowCommentsPreview: React.FC<IPostElementProps> = (props) => {
  const isMobile = props.size === 'xs' || props.size === 'sm'
  const useStyles = makeStyles((theme: Theme) => ({
    iconContainer: {
      padding: '6px 4px',
      textAlign: 'center',
    },
    icon: {
      display: 'inline-block',
      width: '18px',
      height: '18px',
      backgroundImage: 'url(/src/shared/assets/images/preset.png)',
      backgroundSize: 'auto',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: '0 -226px',
    },
    buttonText: {
      fontFamily: ['Roboto', 'sans-serif'].join(','),
      fontSize: isMobile ? '.64rem' : '.75rem',
      fontWeight: 500,
      textTransform: 'inherit',
      verticalAlign: 'middle',
      [theme.breakpoints.down('md')]: {
        fontSize: '.688rem',
      },
    },
  }))
  const classes = useStyles()
  const { t } = useTranslation()

  return (
    <>
      <div className={classes.iconContainer}>
        <span style={{ paddingRight: isMobile ? '5px' : '8px', verticalAlign: 'text-top' }}>
          <i className={classes.icon} />
        </span>
        <span className={classes.buttonText}>
          {t('postCommon:showCommentPreview')}
        </span>
      </div>
    </>
  )
}

export default ShowCommentsPreview
